import { useEffect } from "react";

// Viewport units (100vw / 100dvw) include the classic scrollbar gutter, so
// anything sized against them overflows the page by the scrollbar width.
// Publish the measurement as `--scrollbar-width` so styles can subtract it.
// Resolves to 0px for overlay scrollbars.
const useScrollbarWidth = () => {
  useEffect(() => {
    const measure = () => {
      const width = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty(
        "--scrollbar-width",
        `${Math.max(0, width)}px`,
      );
    };

    measure();

    window.addEventListener("resize", measure);

    // Content growing/shrinking can toggle the scrollbar without a resize event
    const observer = new ResizeObserver(measure);
    observer.observe(document.documentElement);

    return () => {
      window.removeEventListener("resize", measure);
      observer.disconnect();
    };
  }, []);
};

export default useScrollbarWidth;
